import React from "react";
import styled from "styled-components";

import { ModalService } from "../service/modal-service";
import { Box, Col, Text, Button, InputBox } from "../comps";
import { Theme } from "../theme/theme-provider";

import { faCheck } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
`;

const Head = styled(Col)`
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.color.BLUE_4};
`;

const InputWrapper = styled(Box)`
  width: 80%;
  height: 30px;
  margin-top: 20px;
`;

const ButtonWrapper = styled(Box)`
  margin-top: 18px;
`;

export default ({ title, placeholder, submit, onSubmit }) => {
  const inputFieldId = "input-modal-random-id";

  const handleSubmit = () => {
    const inputEle = document.getElementById(inputFieldId);
    const val = inputEle.value;
    onSubmit(val);
    ModalService.closeModal();
  };

  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="20px"
          width="90%"
          color={Theme.textColor.light}
          textAlign="left"
        >
          {title}
        </Text>
      </Head>
      <InputWrapper>
        <InputBox
          id={inputFieldId}
          fontSize="14px"
          background={Theme.color.GRAY_3}
          placeholder={placeholder}
        />
      </InputWrapper>
      <ButtonWrapper>
        <Button
          buttonTextColor={Theme.textColor.light}
          borderRadius="50"
          buttonBackground={Theme.color.BLUE_4}
          buttonName={submit || "done"}
          buttonIcon={faCheck}
          buttonFontSize="14px"
          size="small"
          onClick={handleSubmit}
        />
      </ButtonWrapper>
    </Wrapper>
  );
};
